import { Col, Form, Row } from "antd";
import { ColumnsType } from "antd/lib/table";
import React from "react";
import CheckBox from "../../../../components/atoms/Checkbox";
import InputNumber from "../../../../components/atoms/InputNumber";
import RadioGroup from "../../../../components/atoms/RadioGroup";
import Table from "../../../../components/atoms/Table";
import ExplainWrapper from "../../../../components/molecures/ExplainWrapper";
import sharedConstants from "../../../../shared/constants";
import { daysArray, isDaySelectArray } from "../../../../shared/options";
import { theme } from "../../../../theme";

import { MaximumCount, RenderInputProps } from "../../Interface";
import { MaximumLabelWrapper } from "../../styles";
import DeleteButton from "../DeleteButton";
import PlusButtonRow from "../PlusButtonRow";

const { Item } = Form;
const MaximunVehicleCountInputs: React.FC<RenderInputProps> = ({ form }) => {
  const maximumCounts: MaximumCount[] = Form.useWatch("maximumCounts") || [];
  const isDaySelectOn: boolean = Form.useWatch("isDaySelectOn") || false;
  const columns: ColumnsType<MaximumCount> = [
    {
      title: "추가/삭제",
      width: 112,
      render: (value, record, index) => {
        return (
          <DeleteButton
            fill={
              !isDaySelectOn || maximumCounts.length === 1
                ? theme.colors.gray6
                : theme.colors.red3
            }
            onClick={() => {
              const newTimes = [...maximumCounts];
              for (let i = 0; i < newTimes.length; i += 1) {
                if (i === index) newTimes.splice(i, 1);
              }
              form.setFieldsValue({ maximumCounts: newTimes });
            }}
            disabled={!isDaySelectOn || maximumCounts.length === 1}
          >
            삭제
          </DeleteButton>
        );
      },
    },
    {
      title: "요일",
      key: "days",
      render: (value, record, index) => {
        const disabledValues: string[] = maximumCounts?.reduce(
          (pre: string[], next, valueIndex) => {
            if (valueIndex === index) return pre;
            return [...pre, ...next.days];
          },
          []
        );
        return (
          <ExplainWrapper
            status={
              form.getFieldError("maximumCounts").length > 0 &&
              record?.days.length === 0
                ? {
                    status: "error",
                    explain:
                      sharedConstants.message.ALERT_MESSAGE.DONT_HAVE_DAY,
                  }
                : undefined
            }
          >
            <CheckBox
              options={daysArray}
              disabled={!isDaySelectOn}
              disabledValues={disabledValues}
              value={maximumCounts[index].days || []}
              onChange={(e) => {
                const newTimes = { ...record };
                const newDays = e;
                newTimes.days = newDays;
                const newMaximumTimes = [...maximumCounts];
                newMaximumTimes[index] = newTimes;
                form.setFieldsValue({ maximumCounts: newMaximumTimes });
              }}
            />
          </ExplainWrapper>
        );
      },
    },
    {
      title: "차량 수",
      render: (value, record, index) => {
        return (
          <Row gutter={[8, 12]}>
            <Col span={24}>
              <ExplainWrapper
                status={
                  form.getFieldError("maximumCounts").length > 0 &&
                  (maximumCounts[index].maximumCounts[0] === null ||
                    maximumCounts[index].maximumCounts[0] === undefined)
                    ? {
                        status: "error",
                        explain:
                          sharedConstants.message.ALERT_MESSAGE.NULL_REQUIRED,
                      }
                    : undefined
                }
              >
                <Row gutter={[8, 12]} style={{ width: "100%" }}>
                  <Col>
                    <MaximumLabelWrapper>12시 이전</MaximumLabelWrapper>
                  </Col>
                  <Col>
                    <InputNumber
                      min={0}
                      max={1000}
                      disabled={!isDaySelectOn}
                      controls={false}
                      onChange={(e) => {
                        const newTimes = { ...record };
                        newTimes.maximumCounts[0] = Number(e);
                        const newMaximumTimes = [...maximumCounts];
                        newMaximumTimes[index] = newTimes;
                        form.setFieldsValue({ maximumCounts: newMaximumTimes });
                      }}
                      placeholder="12시 이전"
                      value={maximumCounts[index].maximumCounts[0]}
                    />
                  </Col>
                  <Col>
                    <MaximumLabelWrapper>대</MaximumLabelWrapper>
                  </Col>
                </Row>
              </ExplainWrapper>
            </Col>
            <Col span={24}>
              <ExplainWrapper
                status={
                  form.getFieldError("maximumCounts").length > 0 &&
                  (maximumCounts[index].maximumCounts[1] === null ||
                    maximumCounts[index].maximumCounts[1] === undefined)
                    ? {
                        status: "error",
                        explain:
                          sharedConstants.message.ALERT_MESSAGE.NULL_REQUIRED,
                      }
                    : undefined
                }
              >
                <Row gutter={[8, 0]} style={{ width: "100%" }}>
                  <Col>
                    <MaximumLabelWrapper>12시 이후</MaximumLabelWrapper>
                  </Col>
                  <Col>
                    <InputNumber
                      min={0}
                      max={1000}
                      disabled={!isDaySelectOn}
                      controls={false}
                      onChange={(e) => {
                        const newTimes = { ...record };
                        newTimes.maximumCounts[1] = Number(e);
                        const newMaximumTimes = [...maximumCounts];
                        newMaximumTimes[index] = newTimes;
                        form.setFieldsValue({ maximumCounts: newMaximumTimes });
                      }}
                      placeholder="12시 이후"
                      value={maximumCounts[index].maximumCounts[1]}
                    />
                  </Col>
                  <Col>
                    <MaximumLabelWrapper>대</MaximumLabelWrapper>
                  </Col>
                </Row>
              </ExplainWrapper>
            </Col>
          </Row>
        );
      },
    },
  ];
  const disabledValues: string[] = maximumCounts?.reduce(
    (pre: string[], next) => {
      return [...pre, ...next.days];
    },
    []
  );
  const maximumMorningVehicleCount = Form.useWatch(
    ["repairShopBusiness", "maximumMorningVehicleCount"],
    form
  );
  const maximumAfternoonVehicleCount = Form.useWatch(
    ["repairShopBusiness", "maximumAfternoonVehicleCount"],
    form
  );
  return (
    <Row gutter={[0, 12]}>
      <Col span={24} />
      <Col span={24}>
        <ExplainWrapper
          status={
            form.getFieldError([
              "repairShopBusiness",
              "maximumMorningVehicleCount",
            ]).length > 0 ||
            form.getFieldError([
              "repairShopBusiness",
              "maximumAfternoonVehicleCount",
            ]).length > 0
              ? maximumAfternoonVehicleCount === null &&
                maximumMorningVehicleCount === null
                ? {
                    status: "error",
                    explain: "필수 값입니다",
                  }
                : {
                    status: "error",
                    explain:
                      "일일 최대 예약 가능 대수는 최소 1대 이상이어야 합니다.",
                  }
              : undefined
          }
        >
          <Row gutter={[0, 12]} align="middle">
            <Col span={24}>
              <Row align="middle" gutter={[12, 0]} wrap={false}>
                <Col
                  flex="0 0 100px"
                  style={{
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                  }}
                >
                  오후 12시 이전
                </Col>
                <Col flex="0 0 200px">
                  <Item
                    noStyle
                    name={["repairShopBusiness", "maximumMorningVehicleCount"]}
                    rules={[{ required: true, message: "필수 값입니다" }]}
                  >
                    <InputNumber
                      max={1000}
                      status={
                        form.getFieldError([
                          "repairShopBusiness",
                          "maximumMorningVehicleCount",
                        ]).length > 0
                          ? "error"
                          : undefined
                      }
                      placeholder="오후 12시 이전"
                      style={{ width: "100%" }}
                      min={0}
                    />
                  </Item>
                </Col>
                <Col>대</Col>
              </Row>
            </Col>
            <Col span={24}>
              <Row align="middle" gutter={[12, 0]}>
                <Col
                  flex="0 0 100px"
                  style={{
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                  }}
                >
                  오후 12시 이후
                </Col>
                <Col flex="0 0 200px">
                  <Item
                    noStyle
                    name={[
                      "repairShopBusiness",
                      "maximumAfternoonVehicleCount",
                    ]}
                    rules={[{ required: true, message: "필수 값입니다" }]}
                  >
                    <InputNumber
                      max={1000}
                      placeholder="오후 12시 이후"
                      style={{ width: "100%" }}
                      status={
                        form.getFieldError([
                          "repairShopBusiness",
                          "maximumAfternoonVehicleCount",
                        ]).length > 0
                          ? "error"
                          : undefined
                      }
                      min={0}
                    />
                  </Item>
                </Col>
                <Col>대</Col>
              </Row>
            </Col>{" "}
          </Row>
        </ExplainWrapper>
      </Col>
      <Col span={24}>
        <RadioGroup
          options={isDaySelectArray}
          value={isDaySelectOn}
          onChange={(e) => {
            form.setFieldsValue({ isDaySelectOn: e.target.value });
          }}
        />
        <Item
          noStyle
          name="maximumCounts"
          rules={[
            {
              validator: () => {
                if (!isDaySelectOn) return Promise.resolve();
                if (maximumCounts.find((val) => val.days?.length === 0)) {
                  return Promise.reject(
                    new Error(
                      sharedConstants.message.ALERT_MESSAGE.NULL_REQUIRED
                    )
                  );
                }
                if (
                  maximumCounts.filter(
                    (val) =>
                      val.maximumCounts.length !== 2 ||
                      val.maximumCounts[0] === null ||
                      val.maximumCounts[0] === undefined
                  )?.length > 0
                )
                  return Promise.reject(
                    new Error(
                      sharedConstants.message.ALERT_MESSAGE.NULL_REQUIRED
                    )
                  );
                return Promise.resolve();
              },
            },
          ]}
        />
        <Item noStyle name="isDaySelectOn" />
        <Table
          pagination={false}
          dataSource={maximumCounts.map((val, index) => ({
            ...val,
            key: val.key || `key${index}`,
          }))}
          columns={columns}
          rowKey="key"
        />
        <PlusButtonRow
          disabled={!isDaySelectOn || disabledValues.length === 7}
          onClick={() => {
            const newTimes: MaximumCount[] = [
              ...maximumCounts,
              {
                days: [],
                maximumCounts: [],
                key: `key${maximumCounts?.length}`,
              },
            ];
            form.setFieldsValue({ maximumCounts: newTimes });
          }}
        />
      </Col>
    </Row>
  );
};
export default MaximunVehicleCountInputs;
